<template>
	<div class="pageTitle">
		<div class="title titles">
			<img src="@/assets/images/h_tline.png" alt="">
			<div class="main">
				<p>{{title}}</p> <span>{{title1}}</span>
			</div>
			<img src="@/assets/images/h_tline.png" alt="">
		</div>
	</div>
</template>
<script>
export default {
	name: 'pageTitle',
	props:['title','title1'],
	data() {
			return {
			}
	}
}
</script>
<style scoped>
.pageTitle {
  visibility: visible;
}

.pageTitle .titles {
  width: 1200px;
  margin: auto;
  padding: 40px 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pageTitle .titles img {
  width: 60px;
  height: 3px;
}

.pageTitle .titles .main {
  text-align: center;
  margin: 0 20px;
}

.pageTitle .titles .main p {
  font-size: 30px;
  padding-bottom: 15px;
}

.pageTitle .titles .main span {
  color: #666;
}

</style>


// WEBPACK FOOTER //
// src/components/common-title/index.vue